import StoreModel from '../StoreModel';
import { Action, ActionCreator, Dispatch } from 'redux';
import { AddVisitDTO, Opportunity, VisitState } from '../../api/model';
import { NotificationActions } from '../notification/notification-actions';
import { AppDispatch, IStore } from '../index';
import { DriverActions } from '../driver';
import { getApi } from '../../api/ApiProvider';

export enum VisitActionsTypes {
    REQUEST_ADD = '[VISIT][REQUEST] save',
    RESULT_ADD = '[VISIT][RESPONSE] save',
    ERROR_ADD = '[VISIT][ERROR] save',

    RESUME_FETCH = '[VISIT][REQUEST] fetch',
    RESUME_RESULT = '[VISIT][RESPONSE] fetch',
    RESUME_ERROR = '[VISIT][ERROR] fetch',

    BY_STATE_FETCH = '[VISIT][REQUEST] byState',
    BY_STATE_RESULT = '[VISIT][RESULT] byState',
    BY_STATE_ERROR = '[VISIT][ERROR] byState',

    ALL_FETCH = '[VISIT][REQUEST] all',
    ALL_RESULT = '[VISIT][RESULT] all',
    ALL_ERROR = '[VISIT][ERROR] all',

    SINGLE_FETCH_VIS = '[VISIT][REQUEST] byId',
    SINGLE_RESULT_VIS = '[VISIT][RESPONSE] byId',
    SINGLE_ERROR_VIS = '[VISIT][ERROR] byId',

    SINGLE_FETCH = '[VISIT][REQUEST] single',
    SINGLE_RESULT = '[VISIT][RESPONSE] single',
    SINGLE_ERROR = '[VISIT][ERROR] single',

}


export interface AddVisitParams extends Action<VisitActionsTypes> {
    payload: Opportunity
}

export class VisitActions {

    public fetchResume(): ActionCreator<void> {
        return async (d: Dispatch) => {

            d({ type: VisitActionsTypes.RESUME_FETCH });

            try {
                const data = await getApi().visit().countByState();
                d({ type: VisitActionsTypes.RESUME_RESULT, payload: data });

            } catch (err) {
                d({ type: VisitActionsTypes.RESUME_ERROR, payload: err });
            }

        }
    }
    public fetchAll() {
        return async (d: Dispatch) => {

            d({ type: VisitActionsTypes.ALL_FETCH });

            try {
                const data = await getApi().visit().all();
                d({ type: VisitActionsTypes.ALL_RESULT, payload: data.content });

            } catch (err) {
                d({ type: VisitActionsTypes.ALL_ERROR, payload: err });
            }

        }
    }

    public fetchAllWithFilters(pageNum?: number, pageSize?: number, search?: string, from?: string, to?: string) {
        return async (d: Dispatch) => {
            d({ type: VisitActionsTypes.ALL_FETCH });

            try {
                const data = await getApi().visit().all(pageNum, pageSize, search, from, to);
                d({ type: VisitActionsTypes.ALL_RESULT, payload: data });

            } catch (err) {
                d({ type: VisitActionsTypes.ALL_ERROR, payload: err });
            }
        }
    }

    fetchWithDriverInfo(id: string, force: boolean): any {
        return async (d: AppDispatch, store: () => IStore) => {

            const isLoaded = StoreModel.isLoaded(store().visit.byId[id]);
            if (!force && isLoaded) {
                return;
            }

            if (!isLoaded) {
                d({ type: VisitActionsTypes.SINGLE_FETCH, payload: { id } });
            }
            try {
                const data = await getApi().visit().byId(id);
                console.log('data', data);
                d({ type: VisitActionsTypes.SINGLE_RESULT, payload: { id, data } })
                if (data.driver) {
                    d(new DriverActions().fetchLocationById(data.driver.id))
                }
            } catch (err) {
                console.log('err', err);
                d({ type: VisitActionsTypes.SINGLE_ERROR, payload: { id, err } })
            }
        }
    }

    fetchVisitById(id: string, force: boolean) {
        return async (d: AppDispatch, store: () => IStore) => {

            const isLoaded = StoreModel.isLoaded(store().visit.visitById[id]);
            if (!force && isLoaded) {
                return;
            }

            if (!isLoaded) {
                d({ type: VisitActionsTypes.SINGLE_FETCH_VIS, payload: { id } });
            }
            try {
                const visit = await getApi().visit().visitById(id);
                console.info("Api visita: ", visit);
                d({ type: VisitActionsTypes.SINGLE_RESULT_VIS, payload: { id, visit } })
            } catch (err) {
                console.log('err', err);
                d({ type: VisitActionsTypes.SINGLE_ERROR_VIS, payload: { id, err } })
            }
        }
    }

    public add(visit: AddVisitDTO,history:any): ActionCreator<void> {
        return (dispatch: AppDispatch) => {

            dispatch({ type: VisitActionsTypes.REQUEST_ADD });
            const notif = new NotificationActions();

            getApi().visit().addVisit(visit).then(ok => {

                const action: AddVisitParams = {
                    type: VisitActionsTypes.RESULT_ADD,
                    payload: ok
                };

                dispatch(notif.addSuccess('Visita', 'Agregada correctamente'));
                dispatch(action);
                history.push('/');
            }, err => {
                const action: AddVisitParams = {
                    type: VisitActionsTypes.ERROR_ADD,
                    payload: err
                };
                dispatch(action);
            });


        };
    }

    fetchByState(state: VisitState) {

        return (dispatch: Dispatch) => {

            dispatch({ type: VisitActionsTypes.BY_STATE_FETCH, state });
            getApi().visit().listByState(state).then(data => {
                dispatch({ type: VisitActionsTypes.BY_STATE_RESULT, payload: data, state });
            }, err => {
                dispatch({ type: VisitActionsTypes.BY_STATE_ERROR, payload: err, state });
            });
        };

    }
}



// WEBPACK FOOTER //
// ./src/store/visit/visit-actions.ts